import { makeStyles } from '@material-ui/core'

/** One constant, shared by the header row and the credential rows (§2). */
const COLUMNS = '6fr 3fr 4fr 5fr 8fr'

const cell = {
  minWidth: 0,
  overflowWrap: 'anywhere' as const
}

const useStyles = makeStyles((theme) => ({
  panel: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  tableHead: {
    '& > div': { ...cell },
    display: 'grid',
    gridTemplateColumns: COLUMNS,
    gap: theme.spacing(1),
    color: theme.palette.text.secondary,
    padding: theme.spacing(1, 0),
    marginTop: theme.spacing(1)
  },
  row: {
    '& > div': { ...cell },
    display: 'grid',
    gridTemplateColumns: COLUMNS,
    gap: theme.spacing(1),
    alignItems: 'center',
    padding: theme.spacing(1),
    borderTop: `1px solid ${theme.palette.divider}`
  },
  // Severity is carried by a left border as well as the tint. A background
  // wash alone is colour as the only carrier of meaning, which fails WCAG
  // 1.4.1 and disappears entirely in dark mode.
  rowCritical: {
    backgroundColor: theme.palette.error.light,
    borderLeft: `3px solid ${theme.palette.error.main}`
  },
  rowWarning: {
    backgroundColor: theme.palette.warning.light,
    borderLeft: `3px solid ${theme.palette.warning.main}`
  },
  rowNormal: {
    borderLeft: '3px solid transparent'
  }
}))

export default useStyles
